import { List, Create, Edit, View, MyPending } from "../Components/index.js";

export default [
    {
        path: "/account/note-sheet",
        component: List,
        name: "account.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/note-sheet/create",
        component: Create,
        name: "account.note-sheet.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/note-sheet/:id/edit",
        component: Edit,
        name: "account.note-sheet.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/note-sheet/:id/view",
        component: View,
        name: "account.note-sheet.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/note-sheet-my-pending",
        component: MyPending,
        name: "account-my-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
